<template>
  <div class="asSupportAuth">
    <slot :openModal="handlerOpenModal">
      <div
        class="asSupportAuth_btn"
        @click="handlerOpenModal"
      >
        {{ $t('writeToSupport') }}
      </div>
      <div class="asSupportAuth_text">
        {{ $t('ifHaveAnyQuestions') }}
      </div>
    </slot>

    <as-modal
      v-model="showModal"
      :btnClose="true"
    >
      <div class="asSupportAuth_modal">
        <div class="asSupportAuth_header">
          {{ $t('weTypicallyReply') }}
        </div>

        <div v-if="errorSend" class="asSupportAuth_notice">
          <div>{{ errorSend }}</div>
        </div>

        <v-form
          class="asSupportAuth_content"
          as="div"
        >
          <v-field
            v-model.trim="localEmail"
            name="email"
            :label="$t('email')"
            rules="required|email"
            v-slot="{ errors }"
          >
            <as-input
              name="email"
              :label="$t('email')"
              :placeholder="$t('input.email')"
              type="email"
              v-model="localEmail"
              :error="getFirstError('email', errors)"
              class="-grey asSupportAuth_input"
              :readonly="emailReadonly"
            />
          </v-field>

          <v-field
            v-model.trim="localUsername"
            name="username"
            :label="$t('firstName')"
            rules="required"
            v-slot="{ errors }"
          >
            <as-input
              name="username"
              :label="$t('firstName')"
              :placeholder="$t('input.firstName')"
              type="text"
              v-model="localUsername"
              class="-grey asSupportAuth_input"
              :error="getFirstError('name', errors)"
              :readonly="usernameReadonly"
            />
          </v-field>

          <v-field
            v-model.trim="message"
            name="message"
            :label="$t('message')"
            rules="required"
            v-slot="{ errors }"
          >
            <as-textarea
              name="message"
              v-model.trim="message"
              class="asSupportAuth_textarea -grey"
              :label="$t('message')"
              :placeholder="$t('input.message')"
              maxlength="500"
              autofocus
              :error="getFirstError('city', errors)"
            />
          </v-field>

          <button
            class="asSupportAuth_btn -modal"
            :class="{
              '-disabled': isDisabled
            }"
            :disabled="isDisabled"
            @click="submit"
            type="submit"
          >
            {{ $t('send') }}
          </button>

          <div class="asSupportAuth_agreement">
            {{ $t('onPressIconsent', { buttonName: $t('send') }) }}
            <a class="asSupportAuth_agreement_link" :href="agreementLink" target="_blank">
              {{ $t('personalDataAgreement') }}
            </a>
          </div>

          <div class="asSupportAuth_tip">
            {{ $t('answerToEmail') }}
          </div>
        </v-form>
      </div>
    </as-modal>

    <as-modal
      v-model="showServicesVariantsModal"
      :btnClose="true"
      typeModal="careServiceModal"
    >
      <template #default>
        <div class="modal-content-wrapper">
          <div class="modal-header-wrapper">
            <span class="title"> {{ $t('techSupport') }} </span>
            <span class="description"> {{ $t('chooseService') }} </span>
          </div>
          <div class="asSupportAuth_servicesVariants">
            <a :href="telegramUrl" target="_blank" class="asSupportAuth_servicesVariants --btn --telegram">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_18923_5901)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.94364 8.74888C8.58077 6.20867 12.3397 4.534 14.2206 3.72489C19.5907 1.4147 20.7065 1.01339 21.4338 1.00014C21.5938 0.997227 21.9514 1.03823 22.1831 1.23267C22.3787 1.39685 22.4326 1.61863 22.4583 1.77429C22.4841 1.92995 22.5162 2.28455 22.4907 2.56163C22.1997 5.7241 20.9405 13.3986 20.2999 16.9406C20.0288 18.4394 19.4951 18.9419 18.9784 18.9911C17.8554 19.098 17.0027 18.2235 15.9151 17.4861C14.2132 16.3323 13.2517 15.614 11.5997 14.488C9.69056 13.1868 10.9282 12.4716 12.0162 11.3027C12.301 10.9969 17.2486 6.34226 17.3444 5.92001C17.3564 5.86721 17.3675 5.67036 17.2544 5.56642C17.1414 5.46248 16.9745 5.49802 16.8541 5.52629C16.6834 5.56636 13.9646 7.42501 8.69761 11.1022C7.92588 11.6503 7.22687 11.9174 6.60058 11.9034C5.91015 11.888 4.58204 11.4996 3.59473 11.1677C2.38374 10.7606 1.42128 10.5453 1.50509 9.85385C1.54874 9.4937 2.02826 9.12538 2.94364 8.74888Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_18923_5901">
                    <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
                  </clipPath>
                </defs>
              </svg>
              <span>{{ $t('connectIn', { service: 'Telegram' }) }}</span>
            </a>
            <a :href="whatsappUrl" target="_blank" class="asSupportAuth_servicesVariants --btn --whatsapp">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_18923_5906)">
                  <path d="M1 22L2.5538 16.3506C1.59499 14.6969 1.09118 12.8223 1.0921 10.9001C1.09487 4.89042 6.00862 0 12.0461 0C14.9759 0.000916667 17.7261 1.13667 19.7948 3.19733C21.8625 5.258 23.0009 7.997 23 10.9102C22.9972 16.9208 18.0835 21.8112 12.0461 21.8112C10.2132 21.8103 8.40702 21.3528 6.80717 20.4838L1 22ZM7.07611 18.5103C8.61978 19.4223 10.0934 19.9687 12.0424 19.9696C17.0602 19.9696 21.1478 15.9051 21.1505 10.9083C21.1524 5.9015 17.0841 1.8425 12.0497 1.84067C7.02822 1.84067 2.9434 5.90517 2.94156 10.901C2.94063 12.9406 3.54115 14.4677 4.54969 16.0655L3.62957 19.4095L7.07611 18.5103ZM17.564 13.5016C17.4959 13.3879 17.3135 13.3201 17.039 13.1835C16.7655 13.0469 15.4198 12.3878 15.1684 12.2971C14.9179 12.2063 14.7355 12.1605 14.5522 12.4337C14.3698 12.7059 13.8448 13.3201 13.6855 13.5016C13.5262 13.6831 13.3659 13.706 13.0924 13.5694C12.8188 13.4328 11.9364 13.1459 10.8911 12.2173C10.0778 11.495 9.52792 10.6031 9.36858 10.3299C9.20924 10.0577 9.352 9.91008 9.48832 9.77442C9.61174 9.6525 9.76187 9.45633 9.8991 9.29683C10.0382 9.13917 10.0833 9.0255 10.1754 8.84308C10.2666 8.66158 10.2215 8.50208 10.1524 8.3655C10.0833 8.22983 9.53621 6.88875 9.30872 6.34333C9.08582 5.81258 8.86017 5.88408 8.69254 5.87583L8.16755 5.86667C7.98518 5.86667 7.6886 5.9345 7.43808 6.20767C7.18756 6.48083 6.4802 7.139 6.4802 8.48008C6.4802 9.82117 7.46111 11.1164 7.59742 11.2979C7.73466 11.4794 9.527 14.2313 12.2726 15.411C12.9256 15.6915 13.4359 15.8593 13.8329 15.9848C14.4887 16.192 15.0855 16.1627 15.5571 16.093C16.083 16.0151 17.1763 15.4339 17.4047 14.7978C17.6331 14.1607 17.6331 13.6153 17.564 13.5016Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_18923_5906">
                    <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
                  </clipPath>
                </defs>
              </svg>
              <span>
                {{ $t('connectIn', { service: 'WhatsApp' }) }}
              </span>
            </a>
            <!-- <div class="asSupportAuth_servicesVariants --btn --email" @click="() => openModal(close)">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_18923_5911)">
                  <path d="M4.7818 2C3.91141 2 3.07667 2.33271 2.46122 2.92493C1.84576 3.51715 1.5 4.32037 1.5 5.15789V14.8421C1.5 15.6796 1.84576 16.4829 2.46122 17.0751C3.07667 17.6673 3.91141 18 4.7818 18H19.2182C20.0886 18 20.9233 17.6673 21.5388 17.0751C22.1542 16.4829 22.5 15.6796 22.5 14.8421V5.15789C22.5 4.32037 22.1542 3.51715 21.5388 2.92493C20.9233 2.33271 20.0886 2 19.2182 2H4.7818ZM2.81272 5.15789C2.81272 4.65538 3.02017 4.17345 3.38945 3.81811C3.75872 3.46278 4.25957 3.26316 4.7818 3.26316H19.2182C19.7404 3.26316 20.2413 3.46278 20.6106 3.81811C20.9798 4.17345 21.1873 4.65538 21.1873 5.15789V5.81389L11.9983 10.3427L2.81272 5.81558V5.15789ZM2.81272 7.23537L11.6989 11.6143C11.7916 11.66 11.8942 11.6838 11.9983 11.6838C12.1023 11.6838 12.2049 11.66 12.2976 11.6143L21.1873 7.23368V14.8429C21.1873 15.3455 20.9798 15.8274 20.6106 16.1827C20.2413 16.5381 19.7404 16.7377 19.2182 16.7377H4.78267C4.26044 16.7377 3.7596 16.5381 3.39032 16.1827C3.02105 15.8274 2.81359 15.3455 2.81359 14.8429L2.81272 7.23537Z" fill="#3C92FE"/>
                </g>
                <defs>
                  <clipPath id="clip0_18923_5911">
                    <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
                  </clipPath>
                </defs>
              </svg>
              <span>{{ $t('connectViaEmail') }}</span>
            </div> -->
          </div>
        </div>
      </template>
    </as-modal>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'

import { Form as VForm, Field as VField } from 'vee-validate'
import AsModal from '@web/components/AsModal.vue'
import AsInput from '@web/components/AsInput/AsInput.vue'
import AsTextarea from '@web/components/AsTextarea.vue'
import Logger from '@web/common/Logger'
import sentry from '@web/common/sentry'
import { useStore } from '@web/store'
import i18n from '@web/plugins/i18n'
import Swal from 'sweetalert2'
import useErrors from '@web/composition/useErrors'
import getBaseUrl from '@web/common/getBaseUrl'
import { useSupportContacts } from '@web/composition/useSupportContacts'

export default defineComponent({
  components: {
    AsModal,
    AsInput,
    AsTextarea,
    VForm,
    VField
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    emailReadonly: {
      type: Boolean,
      default: false
    },
    username: {
      type: String,
      default: ''
    },
    usernameReadonly: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const store = useStore()
    const {
      getFirstError
    } = useErrors()

    const errorSend = ref('')
    const showModal = ref(false)
    const showServicesVariantsModal = ref(false)
    const localEmail = ref(props.email)
    const localUsername = ref(props.username)
    const message = ref('')
    const sending = ref(false)
    const isDisabled = computed(() => !message.value.length || sending.value)
    const category = ref<{ label: string; value: number } | null>(null)
    const agreementLink = computed(() => getBaseUrl('/docs/personal_data_agreement.pdf'))

    const {
      whatsappUrl,
      telegramUrl
    } = useSupportContacts()

    watch(() => showModal.value, (showModal: boolean) => {
      if (!showModal) {
        sending.value = false
      }
    })

    async function submit () {
      errorSend.value = ''
      try {
        if (!message.value.length || !localEmail.value.length || !localUsername.value.length) return

        sending.value = true

        const data: {
          name: string,
          email: string,
          message: string,
          supportCategoryId?: number
        } = {
          name: localUsername.value,
          email: localEmail.value,
          message: message.value
        }

        if (category.value) {
          data.supportCategoryId = category.value.value
        }

        await store.dispatch('faq/sendTechQuestionAnonymous', data)
        message.value = ''
        showModal.value = false
        Swal.fire({
          icon: 'success',
          title: `${i18n.global.t('successfully')}!`,
          text: i18n.global.t('messageSent')
        })
      } catch (error) {
        Logger.log('error', error)
        sentry.captureException(error)
        Logger.error(error)
        errorSend.value = i18n.global.t('errorTryLoadData')
      } finally {
        sending.value = true
      }
    }

    function openModal (closeCallback: () => void) {
      showServicesVariantsModal.value = false
      closeCallback?.()
      showModal.value = true
    }

    function openServicesVariantsModal () {
      showServicesVariantsModal.value = true
    }

    function handlerOpenModal () {
      if (telegramUrl.value || whatsappUrl.value) {
        openServicesVariantsModal()
        return
      }

      openModal(() => {})
    }

    return {
      getFirstError,
      errorSend,
      showModal,
      showServicesVariantsModal,
      localEmail,
      localUsername,
      message,
      isDisabled,
      agreementLink,
      submit,
      openModal,
      openServicesVariantsModal,
      telegramUrl,
      whatsappUrl,
      handlerOpenModal
    }
  }
})
</script>

<style lang="scss" scoped>
  @import '@vars';

  .asSupportAuth {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 35px;
    right: 45px;

    @media (max-width: $bp-desktop) {
      position: relative;
      bottom: unset;
      right: unset;
    }

    &_btn {
      width: 177px;
      height: 42px;
      border-radius: 100px;
      background: #7EA9FE;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      text-transform: uppercase;
      margin-bottom: 10px;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;
      cursor: pointer;

      &.-modal {
        background: linear-gradient(45deg, #2850FB 0%, #3D97FE 100%);
        border: 1px solid #2850FB;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: white;
        width: 100%;
        text-transform: none;
        border-radius: 8px;
        margin-top: 20px;
      }
      &.-disabled.-modal {
        background: white;
        color: #2850FB;
      }
    }

    &_text {
      width: 177px;
      font-style: normal;
      font-weight: normal;
      font-size: 9px;
      line-height: 12px;
      text-align: center;
      color: rgba(255, 255, 255, 0.9);

      @media (max-width: $bp-desktop) {
        width: 100%;
      }
      margin-bottom: 10px;
    }

    &_modal {
      width: 100%;
      padding: 18px 20px;
      background-color: white;
    }

    &_header {
      padding-right: 25px;
      padding-bottom: 20px;
      font-size: 16px;
      line-height: 20px;
    }

    &_notice {
      font-size: 12px;
      text-align: center;
      border: 1px solid;
      border-radius: 8px;
      padding: 12px 16px;
    }

    &_content {
      display: flex;
      flex-direction: column;
      margin-top: 8px;
    }

    &_textarea {
      margin-bottom: 10px;
    }

    &_button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 58px;
      text-decoration: none;
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      line-height: 13px;
      text-align: center;
      border: 0;

      margin: 20px auto 0;
      border-radius: 10px;
      outline: none;
      background: blue;
    }

    &_agreement {
      font-size: 13px;
      font-style: normal;
      font-weight: 300;
      line-height: 140%;
      color: var(--ac-color-dark-gray);
      text-align: center;
      margin-top: 8px;

      &_link {
        color: $colorMain;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          text-decoration: none;
        }
      }
    }

    &_tip {
      font-size: 13px;
      font-style: normal;
      font-weight: 300;
      line-height: 140%;
      color: var(--ac-color-dark-gray);
      text-align: center;
      margin-top: 8px;
    }
  }
</style>

<style scoped lang="scss">
.modal-content-wrapper {
  padding: 14px 20px 22px 20px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.modal-header-wrapper {
  display:flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 26px;

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  .title {
    font-size: 28px;
    font-weight: 400;
    color: var(--ac-color-black);

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .description {
    font-size: 14px;
    line-height: 17px;
    font-weight: 400;
    color: var(--ac-color-dark-gray);
  }
}
.asSupportAuth_servicesVariants {
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: var(--ac-color-white);

  &.--btn{
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    padding: 14px 24px;
    border-radius: 32px;
    height: 50px;
    cursor: pointer;
    text-decoration: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;

    svg{
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &.--telegram {
    background-color: #28A8E8;
  }
  &.--whatsapp {
    background-color: #25D366;
  }
  &.--email {
    border: 1px solid var(--ac-color-blue);
    color: var(--ac-color-blue);
  }
}
</style>
